import {api} from "@core/api";
import {SearchParams} from "@core/api/query/queryEntity";
import {BaseEntity, entity, Pageable} from "@core/model";
import {useEffect, useState} from "react";

const useAdvancedSearch = <T extends BaseEntity>(
  entity: entity,
  params: SearchParams | undefined,
  onSearch?: (data: T[]) => void,
) => {
  const [results, setResults] = useState<Pageable<T>>();

  const [search, {isLoading, isFetching, isUninitialized}] =
    api.useLazyAdvancedSearchQuery();

  useEffect(() => {
    if (params) {
      doSearch(entity, params);
    }
  }, [params, entity, onSearch]);

  const doSearch = (entity: entity, body: SearchParams) => {
    search({entity, body})
      .unwrap()
      .then(results => {
        setResults(results as Pageable<T>);
        onSearch?.(results.content as T[]);
      });
  };

  const refetch = () => {
    if (params) {
      doSearch(entity, params);
    }
  };

  return {results, isLoading, isFetching, isUninitialized, refetch};
};

export {useAdvancedSearch};
